import * as React from "react";
const IcoFacebook = () => (
  <svg
    width={"100%"}
    height={"100%"}
    viewBox="40 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 33">
      <path
        id="Vector_2"
        d="M66 3.97222V22.0278C66 24.217 64.217 26 62.0278 26H58.0556V15.8889H60.6698C61.0385 15.8889 61.3488 15.6143 61.3921 15.2532L61.6591 13.0865C61.6892 12.8853 61.6234 12.6746 61.4861 12.5242C61.3488 12.3643 61.1532 12.2778 60.9444 12.2778H58.0556V9.75C58.0556 8.95631 58.7063 8.30556 59.5 8.30556H60.9444C61.3413 8.30556 61.6667 7.98018 61.6667 7.58333V5.14207C61.6667 4.77344 61.377 4.46311 61.0103 4.42737C60.967 4.41985 59.9476 4.33333 58.6555 4.33333C55.477 4.33333 53.7222 6.22541 53.7222 9.65596V12.2778H50.8333C50.4365 12.2778 50.1111 12.6032 50.1111 13V15.1667C50.1111 15.5635 50.4365 15.8889 50.8333 15.8889H53.7222V26H43.9722C41.783 26 40 24.217 40 22.0278V3.97222C40 1.78299 41.783 0 43.9722 0H62.0278C64.217 0 66 1.78299 66 3.97222Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export default IcoFacebook;
